import React from 'react'
import {
  AmexIcon,
  CreditCardIcon,
  DiscoverIcon,
  GooglePayAltIcon,
  MastercardAltIcon,
  PaypalAltIcon,
  VisaAltIcon,
  ApplePayIcon,
  KlarnaIcon,
} from '../icons'
import {PAYMENT_METHOD_IDS, CARD_TYPES, CARD_TYPES_CODE} from '../../utils/constants'
import {BoxProps} from '../../vanilla'
import {FilteredPaymentMethod} from '../../types/store/common'

interface CardTypeIconProps extends BoxProps<any> {
  cardType?: CARD_TYPES_CODE
  customURL?: string
}
interface AvailablePaymentMethodsIconsProps extends BoxProps<any> {
  availablePaymentMethods: Array<FilteredPaymentMethod>
  isFooter?: boolean
}

export const CreditCardTypeIcon = ({cardType, customURL, ...boxProps}: CardTypeIconProps) => {
  
  if (customURL) {
    return <img height="44px" width="44px" src={customURL} />
  }
  
  switch (cardType) {
    case CARD_TYPES.AMERICAN_EXPRESS:
      return <AmexIcon height="44px" width="44px" {...boxProps} />
    case CARD_TYPES.DISCOVER:
      return <DiscoverIcon height="44px" width="44px" {...boxProps} />
    case CARD_TYPES.MASTERCARD:
      return <MastercardAltIcon height="44px" width="44px" {...boxProps} />
    case CARD_TYPES.VISA:
      return <VisaAltIcon height="44px" width="44px" {...boxProps} />
    case CARD_TYPES.PAYPAL:
      return <PaypalAltIcon height="44px" width="44px" {...boxProps} />
    case CARD_TYPES.CREDIT_CARD:
      return <CreditCardIcon height="44px" width="44px" {...boxProps} />
    case CARD_TYPES.APPLE_PAY:
      return <ApplePayIcon height="44px" width="44px" {...boxProps} />
    case CARD_TYPES.GOOGLE_PAY:
      return <GooglePayAltIcon height="44px" width="44px" {...boxProps} />
    case CARD_TYPES.KLARNA:
      return <KlarnaIcon height="44px" width="44px" {...boxProps} />
    default:
      return null
  }
}

export const AvailablePaymentMethodsIcons = ({
  availablePaymentMethods,
  isFooter = false,
  ...boxProps
}: AvailablePaymentMethodsIconsProps) => {
  return (
    <>
      {availablePaymentMethods.map((method) => {
        switch (method.id) {
          case PAYMENT_METHOD_IDS.PAYPAL:
            return <PaypalAltIcon key={method.id} height={isFooter ? '30px' : '44px'} width={isFooter ? '88px' : '44px'} {...boxProps} />
          case PAYMENT_METHOD_IDS.BT_CREDIT_CARD:
            return (
              <>
                <VisaAltIcon key="Visa" height={isFooter ? '30px' : '44px'} width={isFooter ? '60px' : '44px'} {...boxProps} />
                <MastercardAltIcon
                  key="Mastercard"
                  height={isFooter ? '30px' : '44px'} 
                  width={isFooter ? '60px' : '44px'}
                  {...boxProps}
                />
              </>
            )
          case PAYMENT_METHOD_IDS.GOOGLE_PAY:
            return <GooglePayAltIcon key={method.id} height={isFooter ? '48px' : '44px'} width={isFooter ? '60px' : '44px'} {...boxProps} />
          case PAYMENT_METHOD_IDS.APPLE_PAY:
            return <ApplePayIcon key={method.id} height={isFooter ? '48px' : '44px'} width={isFooter ? '60px' : '44px'} {...boxProps} />
          case PAYMENT_METHOD_IDS.KLARNA:
            return <KlarnaIcon key={method.id} height={isFooter ? '48px' : '44px'} width={isFooter ? '60px' : '44px'} {...boxProps} />
          default:
            return null
        }
      })}
    </>
  )
}
